import { type CartPageState, initialCartPageState } from "../types";
import { type TransformedCartData } from "../../transformers/CartViewDataTransformer";
import { type AnyAction } from "../../../../../redux/types";
import { CART_LOAD_FAIL, CART_LOAD_START, CART_LOAD_SUCCESS } from "~/feature/cart/cart/redux/actions";
import { BLOCK_SCREEN, UNBLOCK_SCREEN } from "~/feature/cart/cart/redux/actions/actionTypes";
import { LOAD_CART_NONCART_PAGE } from "~/AddToCart/redux/cartAmounts/actionTypes";

const pageReducer = (state = initialCartPageState, action: AnyAction): CartPageState => {
  switch (action.type) {
    case BLOCK_SCREEN: {
      const blockScreenMessage = action.payload as string;
      return {
        ...state,
        requestInFlight: true,
        requestInFlightMessage: blockScreenMessage,
      };
    }

    case UNBLOCK_SCREEN: {
      return {
        ...state,
        requestInFlight: false,
        requestInFlightMessage: "",
      };
    }

    case CART_LOAD_START: {
      return {
        ...state,
        loading: true,
        error: false,
      };
    }

    case CART_LOAD_SUCCESS:
    case LOAD_CART_NONCART_PAGE: {
      const data = action.payload as TransformedCartData;
      return {
        ...state,
        accountNumber: data.accountNumber,
        loading: false,
        error: false,
        dstError: data.dstError,
      };
    }

    case CART_LOAD_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    default:
      return state;
  }
};

export const cartPageReducer = pageReducer;
